module.exports = __webpack_public_path__ + "static/img/Logo1.82f7290.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo1.png
// module id = o9xs
// module chunks = 1